import React from 'react';

const ServerSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g>
      <rect fill="#3573f0" x="2" y="3" width="20" height="6" rx="1" />
      <circle fill="#fadfb2" cx="6" cy="6" r="1" />
      <circle fill="#fadfb2" cx="10" cy="6" r="1" />
      <rect fill="#2e55a3" x="2" y="10" width="20" height="6" rx="1" />
      <circle fill="#fadfb2" cx="6" cy="13" r="1" />
      <circle fill="#fadfb2" cx="10" cy="13" r="1" />
      <rect fill="#3573f0" x="2" y="17" width="20" height="4" rx="1" />
      <circle fill="#fadfb2" cx="6" cy="19" r="1" />
      <circle fill="#fadfb2" cx="10" cy="19" r="1" />
    </g>
  </svg>
);

export default ServerSvg;
